import { useEffect, useMemo, useState } from 'react'

export const useFeatureFlag = (flag: FeatureFlagName): boolean => {
  const flags = useMemo(() => window?.FeatureFlags ?? {}, [])
  const [isEnabled, setIsEnabled] = useState(Boolean(flags[flag]))

  useEffect(() => {
    setIsEnabled(Boolean(flags[flag]))
  }, [flags, flag])

  return isEnabled
}
